import React from 'react';

const EtablissementInfoCard = ({ icon: Icon, title, children, iconBgColor = "bg-[#202654]/10", iconColor = "text-[#202654]" }) => {
  return (
    <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300 overflow-hidden group">
      <div className="p-6">
        <div className="flex items-center mb-4">
          <div className={`bg-gradient-to-br from-[#202654] to-[#2a2f6a] p-3 rounded-xl mr-4 shadow-md group-hover:shadow-lg transition-all duration-300`}>
            <Icon className="h-6 w-6 text-white" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>
        <div className="text-gray-700">
          {children}
        </div>
      </div>
    </div>
  );
};

export default EtablissementInfoCard; 